module.exports = __webpack_public_path__ + "static/media/rattle.167aaa2f.PNG";